import { z } from 'zod';

const obligateField = 'Este campo es obligatorio';

export const NewProfileSchema = z.object({
	name: z
		.string({ required_error: obligateField })
		.min(1, { message: obligateField }),
	permissions: z
		.array(z.string())
		.min(1, { message: 'Debe seleccionar al menos un permiso' }),
});
